export default "__VITE_ASSET__DXL2e8KA__"